/* eslint-disable @typescript-eslint/naming-convention */
import * as env from './domains/survey-force.enviroments';

export const environment = {
    production: true,
    TRACKING_SDK: {
        enabled: true,
        url: 'https://apex.vinid.net/base-platform/sdk/v1.3.0/platform.js',
        clientId: process.env.TRACKING_CLIENT_KEY_PROD,
        env: 'production'
    },
    domain: {
        ...env.surveyForceProd,
    },
};
